import { translate } from '@/translation/native_translate';

/**
 * Scroll to absolute coordinates of an element using query selector
 * @param {string} cssSelectors CSS selector string to locate the element
 * @param {string} behavior options are 'smooth' (default), 'instant', 'auto'
 */
function scrollToElement(cssSelectors, behavior = 'smooth') {
  const element = document.querySelector(cssSelectors);
  if (element != null) {
    const elementTop = element.offsetTop;
    window.scrollTo({
      top: elementTop,
      left: 0,
      behavior,
    });
  }
}

/**
 * Scroll to an element using query selector
 * @param {string} cssSelectors CSS selector string to locate the element
 * @param {string} behavior options are 'smooth' (default), 'instant', 'auto'
 */
function scrollIntoView(cssSelectors) {
  const element = document.querySelector(cssSelectors);
  if (element != null) {
    element.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
      inline: 'center',
    });
  }
}

/**
 * Check if current connection is localhost
 * @returns true if connection is localhost; otherwise false
 */
function isLocalhost() {
  if (location.hostname === 'localhost' || location.hostname === '127.0.0.1') {
    return true;
  }

  return false;
}

/**
 * Check if current device is touch screen or not
 * @returns true if touchscreen
 */
function isTouchScreen() {
  return (
    'ontouchstart' in window ||
    navigator.maxTouchPoints > 0 ||
    navigator.msMaxTouchPoints > 0
  );
}

/**
 * Format price to euro
 * @param {number} price price in number that needs to be formatted to currency (euro)
 * @returns formatted price in euro
 */
function toCurrency(price) {
  return new Intl.NumberFormat('nl-NL', {
    style: 'currency',
    currency: 'EUR',
  }).format(price);
}

export default class utility {
  static months = [
    'JAN',
    'FEB',
    'MAR',
    'APR',
    'MAY',
    'JUN',
    'JUL',
    'AUG',
    'SEP',
    'OCT',
    'NOV',
    'DEC',
  ];

  /**
   * static to parse the replied property Matrix
   * in one array of objects, all the columns will
   * be object properties.
   */
  static createArrayWithObjects = (object) => {
    let outputArray = [];
    for (let i = 0; i < object.celldata.length; i++) {
      const translateObj = {};
      for (let data in object.columns) {
        if (object.columns.hasOwnProperty(data)) {
          let index = object.columns[data];
          switch (data) {
            default:
              translateObj[data] = object.celldata[i][index];
          }
        }
      }
      outputArray.push(translateObj);
    }
    return outputArray;
  };

  static objectToArray = (object) => {
    let a = [];
    for (const [k, v] of Object.entries(object)) {
      a.push({ ...v });
    }
    return a;
  };

  static dateFromDMYToYMD(dateDMY) {
    // Date from 20-09-2020 to 2020-09-20
    const [day, month, year] = dateDMY.split('-');
    const dateYMD = `${year}-${month}-${day}`;
    return dateYMD;
  }

  static dateFromYMDToDMY(dateYMD) {
    // Date from 2020-09-20 to 20-09-2020
    const [year, month, day] = dateYMD.split('-');
    const dateDMY = `${day}-${month}-${year}`;
    return dateDMY;
  }

  static getCurrentDateYMD() {
    const toTwoDigits = (num) => (num < 10 ? `0${num}` : num);
    const today = new Date();

    const year = today.getFullYear();
    const month = toTwoDigits(today.getMonth() + 1);
    const day = toTwoDigits(today.getDate());
    return `${year}-${month}-${day}`;
  }

  static getCurrentDateDMY() {
    const toTwoDigits = (num) => (num < 10 ? `0${num}` : num);
    const today = new Date();

    const year = today.getFullYear();
    const month = toTwoDigits(today.getMonth() + 1);
    const day = toTwoDigits(today.getDate());
    return `${day}-${month}-${year}`;
  }

  /**
   * @param {(string | Date)} date - Date in format YYYY-MM-DD
   * @param {number} days - Either positive or negtive
   */
  static addDays(date, days) {
    const dateIn = new Date(date);
    dateIn.setDate(dateIn.getDate() + days);

    const toTwoDigits = (num) => (num < 10 ? `0${num}` : num);

    const year = dateIn.getFullYear();
    const month = toTwoDigits(dateIn.getMonth() + 1);
    const day = toTwoDigits(dateIn.getDate());
    return `${day}-${month}-${year}`;
  }

  static dateToNumber(input) {
    var result = -1;
    if (input.split('-').length < 3) {
      console.log("couldn't split date ", input);
      return result;
    }
    let day = input.split('-')[0];
    let month = input.split('-')[1];
    let year = input.split('-')[2];

    result = Number(year + month + day);
    return result;
  }

  static currentDateNumber() {
    let d = new Date();
    return Number(
      d.getFullYear().toString() +
        (d.getMonth() + 1).toString().padStart(2, '0') +
        d.getDate().toString().padStart(2, '0')
    );
  }

  /**
   * @param {(string | number)} unixTime '1624453916' / 1624453916
   * @returns {string} time date: '15:11 23-06-2020'
   */
  static unixTimeToDateTimeString(unixTime) {
    if (unixTime == null || unixTime === '' || unixTime < 0) {
      return '';
    }

    const unixTimeInt = parseInt(unixTime);
    if (isNaN(unixTimeInt)) {
      return '';
    }

    const unixTimeMilliseconds = unixTimeInt * 1000;
    const dateObj = new Date(unixTimeMilliseconds);

    const hours = utility.numberPadding(dateObj.getHours());
    const minutes = utility.numberPadding(dateObj.getMinutes());

    const year = dateObj.getFullYear();
    const month = utility.numberPadding(dateObj.getMonth() + 1);
    const day = utility.numberPadding(dateObj.getDate());

    return `${hours}:${minutes} ${day}-${month}-${year}`;
  }

  static roundPrice(price) {
    return Number(price).toFixed(2).replace('.', ',');
  }

  static toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  static getFullUrl(rawUrl) {
    if (rawUrl == null) {
      return '';
    }

    let fullUrl = rawUrl;
    if (!rawUrl.match(/^http[s]?:\/\//)) {
      fullUrl = `http://${rawUrl}`;
    }

    return fullUrl;
  }

  static numberPadding(num) {
    if (num == null || isNaN(parseInt(num))) {
      return num;
    }

    return parseInt(num) < 10 ? `0${num}` : num.toString();
  }

  static getRandomString(
    len = 8,
    includeLowercase = true,
    includeUppercase = true,
    includeNumbers = true,
    includeSymbols = true
  ) {
    const lowercaseChars = 'abcdefghijklmnopqrstuvwxyz';
    const uppercaseChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    const numbers = '0123456789';
    const symbols = '!@#$%^&*_-+=';

    // Get charactor options
    let chars = '';
    if (
      !includeLowercase &&
      !includeUppercase &&
      !includeNumbers &&
      !includeSymbols
    ) {
      // No option is checked, use lowercase chars by default
      chars = lowercaseChars;
    } else {
      if (includeLowercase) chars = chars.concat(lowercaseChars);
      if (includeUppercase) chars = chars.concat(uppercaseChars);
      if (includeNumbers) chars = chars.concat(numbers);
      if (includeSymbols) chars = chars.concat(symbols);
    }

    let result = '';
    for (let i = 0; i < len; i++) {
      result += chars.charAt(Math.floor(Math.random() * chars.length));
    }

    return result;
  }

  /**
   * Function to copy text to clipboard
   * @param {String} textToBeCopied
   */
  static copyToClipboard(textToBeCopied) {
    window.Clipboard = (function (window, document, navigator) {
      let textArea, copy;

      // const parentEl = document.getElementById('');

      function isOS() {
        return navigator.userAgent.match(/ipad|iphone/i);
      }

      function createTextArea(text) {
        textArea = document.createElement('textArea');
        textArea.value = text;

        // parentEl.appendChild(textArea);
        document.body.appendChild(textArea);
      }

      function selectText() {
        let range, selection;

        if (isOS()) {
          range = document.createRange();
          range.selectNodeContents(textArea);
          selection = window.getSelection();
          selection.removeAllRanges();
          selection.addRange(range);
          textArea.setSelectionRange(0, 999999);
        } else {
          textArea.select();
        }
      }

      function copyToClipboard() {
        const success = document.execCommand('copy');
        if (success) {
          window.EventBus.fire(
            'activateSnackBar',
            translate('COPY_TO_CLIPBOARD_SUCCEEDED')
          );
        } else {
          window.EventBus.fire(
            'activateSnackBar',
            translate('COPY_TO_CLIPBOARD_FAILED')
          );
        }

        // parentEl.removeChild(textArea);
        document.body.removeChild(textArea);
      }

      copy = function (text) {
        createTextArea(text);
        selectText();
        copyToClipboard();
      };

      return {
        copy: copy,
      };
    })(window, document, navigator);

    window.Clipboard.copy(textToBeCopied);
  }

  /**
   * Convert line breaks in the text to html tag <br>
   * @param {string} text Raw content to be converted
   * @returns {string} Converted text
   */
  static lineBreaksToHtml(text) {
    if (typeof text !== 'string') {
      return text;
    }

    return text.replaceAll('\n', '<br>');
  }

  /**
   * @example sprintf("one %s, two %d, three %v", 1, 2, 3)
   * @param {String} str
   * @param  {...any} args
   * @returns {String} "one: 1, two: 2, three: 3"
   */
  static sprintf(str, ...args) {
    return args.reduce((_str, val) => _str.replace(/%s|%v|%d|%f|%d/, val), str);
  }

  /**
   * @param {number} priceInclVAT e.g. 4.99
   * @param {number} vatPercentage e.g. 10, which means 10 percent vat
   */
  static getPriceExclVAT(priceInclVAT, vatPercentage) {
    const vatPrice = utility.getVatPrice(priceInclVAT, vatPercentage);
    if (vatPrice == null) {
      return null;
    }

    return priceInclVAT - vatPrice;
  }

  static getVatPrice(price, vatPercentage) {
    if (typeof price !== 'number' || typeof vatPercentage !== 'number') {
      return null;
    }

    // return price * (vatPercentage / 100.0);
    return (price * vatPercentage) / (100 + vatPercentage);
  }

  /**
   * Get the price after taking the discount percentage into account
   * @param {number} retailPrice original price without discount
   * @param {number} discountPercentage discount percentage, e.g. 10, which refers to 10 percent discount
   * @returns price with discount, or null if input `retailPrice` is invalid, or `retailPrice` if `discountPercentage` is invalid
   */
  static getDiscountPrice(retailPrice, discountPercentage) {
    if (retailPrice == null || typeof retailPrice !== 'number') {
      return null;
    }

    if (discountPercentage == null || typeof discountPercentage !== 'number') {
      return retailPrice;
    }

    return (
      Math.round(
        100 * (retailPrice - retailPrice * (discountPercentage / 100.0))
      ) / 100.0
    );
    // return priceInclVAT * (1 - vatNr);
    // return priceInclVAT - (priceInclVAT * vatPercentage) / (100.0 + vatPercentage);
  }
}

export {
  scrollToElement,
  scrollIntoView,
  isLocalhost,
  isTouchScreen,
  toCurrency,
};
